// Reducer that changes the state based on the action

import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const slice = createSlice({
  name: "profile",
  initialState: {
    isLoading: false,
    data: [],
    userProfile: { },
    badgeValue: 0,
    success: false,
    updateSuccess: false,
    error: null
  },
  reducers: {
    startFetching: (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
      state.updateSuccess = false;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
      state.isLoading = false;
    },
    setUpdateSuccess: (state, action) => {
      state.updateSuccess = action.payload;
      state.isLoading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setData: (state, action) => {
      state.data = action.payload;
      state.success = true;
      state.isLoading = false;
    },
    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
      state.error = null
      state.isLoading = false;
    },
    setSupervisorData: (state, action) => {
      state.userProfile = action.payload;
      state.error = null
      state.isLoading = false;
    },
    setUserBadges: (state, action) => {
      state.badgeValue = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  startFetching,
  setSuccess,
  setUpdateSuccess,
  setError,
  setData,
  setUserProfile,
  setSupervisorData,
  setUserBadges
} = slice.actions;

export const useData = () => useSelector((state) => state.Profile.data);
export const useUserProfile = () => useSelector((state) => state.Profile.userProfile);
export const useBadgeValue = () => useSelector((state) => state.Profile.badgeValue);
export const useIsLoading = () => useSelector((state) => state.Profile.isLoading);
export const useSuccess = () => useSelector((state) => state.Profile.success);
export const useUpdateSuccess = () => useSelector((state) => state.Profile.updateSuccess);
export const useRemovedUser = () => useSelector((state) => (state.Profile.userProfile.supervisor?.removed_user || []));
export const useError = () => useSelector((state) => state.Profile.error);

export default slice.reducer;
